import { useEffect, useState } from 'react';

interface SafeAreaInsets {
  top: number;
  bottom: number;
}

function resolveInsets(): SafeAreaInsets {
  const style = getComputedStyle(document.documentElement);
  return {
    top: parseFloat(style.getPropertyValue('--safe-area-inset-top')) || 0,
    bottom: parseFloat(style.getPropertyValue('--safe-area-inset-bottom')) || 0,
  };
}

export function useSafeAreaInsets(): SafeAreaInsets {
  const [insets, setInsets] = useState<SafeAreaInsets>({ top: 0, bottom: 0 });

  useEffect(() => {
    setInsets(resolveInsets());
  }, []);

  return insets;
}
